module.exports = __webpack_public_path__ + "img/horizontal_6_1_pp1_9016.4ac68d3e.png";